import { $body } from '../../../../../../ig_template/Resources/Public/Src/Js/Constants';
import SwiperSlider from '../../../../../../ig_template/Resources/Public/Src/Js/Elements/SwiperSlider';

/**
 * Teaser Slider
 */
const TeaserSlider = (($) => {
  /**
   * Selector
   *
   * @var { Object }
   */
  const Selector = {
    TEASER_SLIDER: '.ig-teasers-type-3.swiper-container',
  };

  /**
   * Teaser Slider
   *
   * @class
   * @augments SwiperSlider
   */
  class TeaserSlider extends SwiperSlider {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      super.onReady();

      this.setOptions({
        spaceBetween: 30,
        slidesPerView: 5,
        grabCursor: true,
        pagination: {
          el: this.constructor.Selector.PAGINATION,
          clickable: true
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        breakpoints: {
          1600: {
            slidesPerView: 4
          },
          1200: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 2
          },
          550: {
            slidesPerView: 1
          }
        }
      });

      this._initialize();
    }
  }

  return (new TeaserSlider($body.find(Selector.TEASER_SLIDER)));
})($);

export default TeaserSlider;
